import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { getMe } from "@/features/auth/services/user.service";
import type { UserResponse } from "@/shared/types/";

type UseUserQueryProps = {
  enabled: boolean
  onGetMeSuccess: (user: UserResponse) => void
  onGetMeError: () => void
};

export const useUserQuery = ({ enabled, onGetMeSuccess, onGetMeError }: UseUserQueryProps) => {
  const query = useQuery<UserResponse>({
    queryKey: ["user"],
    queryFn: () => getMe(),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  useEffect(() => {
    if (query.isSuccess && query.data) {
      onGetMeSuccess(query.data);
    }
  }, [query.isSuccess, query.data, onGetMeSuccess]);

  useEffect(() => {
    if (query.isError) {
      onGetMeError();
    }
  }, [query.isError, onGetMeError]);

  return query;
};
